'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FormatInfo = require('./components/FormatInfo.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FormatInfo).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-format-info/lib/index.js
// module id = 367
// module chunks = 1